import { authenticatedAjax, REQUEST } from "../../../config/ajax-wrapper";
import { AnyAction } from "redux";
import {
    CONSULTAR_TAREAS, ERROR_CONSULTANDO_TAREAS, ERROR_REINTENTANDO_TAREA, errorConsultandoTareas,
    errorReintentandoTarea, REINTENTAR_TAREA,
    REINTENTO_ENVIADO,
    reintentoEnviado,
    TAREAS_CONSULTADAS,
    tareasConsultadas
} from "./bandejaActions";
import { errorAutorizacion } from "../../../inicio/modulos/inicioActions";
import { Tarea } from "../modelo/Tarea";
import { obtenerTipoCliente } from "../../documentos/modelo/TiposCliente";
import { DATE_FORMAT_WITH_HOUR } from "../../general/componentes/DatePicker";
import * as moment from "moment";
import { EstadoDocumento } from "../../documentos/modelo/EstadosDocumento";


export const consultarTareasEpic = action$ =>
    action$.ofType(CONSULTAR_TAREAS)
        .mergeMap((action) => {

            var filter = action.filtroTarea.dni ? `dni=${action.filtroTarea.dni}` : "";

            filter += action.filtroTarea.tipoCliente ?
                (filter ? `&tipoCliente=${action.filtroTarea.tipoCliente}` :
                    `tipoCliente=${action.filtroTarea.tipoCliente}`)
                : "";

            filter += action.filtroTarea.estado ?
                (filter ? `&estado=${action.filtroTarea.estado}` : `estado=${action.filtroTarea.estado}`)
                : "";

            filter += action.filtroTarea.tamanoPagina ?
                (filter ? `&registrosPorPagina=${action.filtroTarea.tamanoPagina}` :
                    `registrosPorPagina=${action.filtroTarea.tamanoPagina}`)
                : "";

            filter += action.filtroTarea.paginaActual ?
                (filter ? `&pagina=${(action.filtroTarea.paginaActual + 1)}` :
                    `pagina=${(action.filtroTarea.paginaActual + 1)}`)
                : "";

            
            filter += action.filtroTarea.dniUsuario ?
                (filter ? `&dniUsuario=${(action.filtroTarea.dniUsuario)}` :
                    `dniUsuario=${(action.filtroTarea.dniUsuario)}`)
                : "";

            filter += action.filtroTarea && action.filtroTarea.fechaInicio ?
            (filter ? `&fechaInicio=${action.filtroTarea.fechaInicio}` :
                    `fechaInicio=${action.filtroTarea.fechaInicio}`)
                : ""; 

            filter += action.filtroTarea && action.filtroTarea.fechaFin ?
                (filter ? `&fechaFin=${action.filtroTarea.fechaFin}` :
                        `fechaFin=${action.filtroTarea.fechaFin}`)
                    : ""; 
            

            const url = `tareas?${filter}`;


            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return tareasConsultadas(parseTareas(respuesta), respuesta.paginas);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultandoTareas()];
                });
        });

export const reintentarTareaEpic = action$ =>
    action$.ofType(REINTENTAR_TAREA)
        .mergeMap((action) => {
            return authenticatedAjax
            .post(
                "aprobar-documento", {
                    dni: action.dni,
                    dniAprueba: action.dniAprueba,
                    tipoCliente: action.tipoCliente
                },
                {"Content-Type": "application/json"}
            )
                .map((response) => {
                    return reintentoEnviado();
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorReintentandoTarea()];
                });
        });

export const tareasReducer = (state = {
    estado: REQUEST.NONE,
    estadoReintento: REQUEST.NONE,
    tareas: [],
    tamanoPagina: 10,
    paginaActual: 0
}, action: AnyAction) => {
    switch (action.type) {
        case CONSULTAR_TAREAS:
            return { ...state, estado: REQUEST.PENDING, tareas: [], estadoReintento: REQUEST.NONE, paginaActual: action.filtroTarea.paginaActual,
                tamanoPagina: action.filtroTarea.tamanoPagina };
        case TAREAS_CONSULTADAS:
            return {
                ...state, tareas: action.tareas, estado: REQUEST.SUCCESS,
                paginas: action.paginas
            };
        case ERROR_CONSULTANDO_TAREAS:
            return { ...state, tareas: [], estado: REQUEST.ERROR };
        case REINTENTAR_TAREA:
            return {
                ...state,
                tareas: filtrarTarea(state.tareas, action.dni, action.tipoCliente),
                estadoReintento: REQUEST.PENDING
            };
        case REINTENTO_ENVIADO:
            return {
                ...state,
                estadoReintento: REQUEST.SUCCESS
            };
        case ERROR_REINTENTANDO_TAREA:
            return {
                ...state,
                estadoReintento: REQUEST.ERROR
            };
        default:
            return state;
    }
};

const parseTareas = (respuestaHttp: any): Array<Tarea> => {
    const listaTareas = respuestaHttp.respuesta.map(t => {
        return {
            afiliado: t.afiliado,
            estado: t.estado,
            fechaRegistro: moment(t.fechaRegistro).format(DATE_FORMAT_WITH_HOUR),
            fechaRespuesta: t.fechaRespuesta ? moment(t.fechaRespuesta).format(DATE_FORMAT_WITH_HOUR) : "",
            observacion: t.observacion,
            tipoCliente: obtenerTipoCliente(t.tipoCliente),
            tipoGestion: t.tipoGestion,
            poliza: t.poliza ? t.poliza : "",
            fechaInicioCobertura: t.fechaInicioCobertura ? t.fechaInicioCobertura : ""
        };  
    });

    return listaTareas;
};



const filtrarTarea = (tareas: Array<Tarea>, dni: string, tipoCliente: string) => {
    return tareas.map(t => {
        if (t.afiliado.identificacion === dni && t.tipoCliente.id === tipoCliente) {
            t.estado = EstadoDocumento.pendiente;
        }

        return t;
    });
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/bandeja/modulos/bandejaReducers.ts